import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Browser } from '@capacitor/browser';
import { 
  FaHome, 
  FaClock, 
  FaTachometerAlt, 
  FaExchangeAlt, 
  FaBook, 
  FaBell,
  FaShoppingCart,
  FaQuestionCircle
} from 'react-icons/fa';

const NavBar = () => {
  const location = useLocation();

  const handleExternalLink = (e, url) => {
    e.preventDefault();
    Browser.open({ url });
  };

  // Clase para enlace activo
  const getLinkClassName = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className={`nav-link ${getLinkClassName('/')}`}>
          <FaHome className="nav-icon" />
          <span>Inicio</span>
        </Link>
        
        <Link to="/timer" className={`nav-link ${getLinkClassName('/timer')}`}>
          <FaClock className="nav-icon" />
          <span>Temp.</span>
        </Link>
        
        <Link to="/estimador" className={`nav-link ${getLinkClassName('/estimador')}`}>
          <FaTachometerAlt className="nav-icon" />
          <span>Presión</span>
        </Link>
        
        <Link to="/retorno" className={`nav-link ${getLinkClassName('/retorno')}`}>
          <FaExchangeAlt className="nav-icon" />
          <span>Retorno</span>
        </Link>
        
        <Link to="/bitacora" className={`nav-link ${getLinkClassName('/bitacora')}`}>
          <FaBook className="nav-icon" />
          <span>Bitácora</span>
        </Link>
        
        <Link to="/alertas" className={`nav-link ${getLinkClassName('/alertas')}`}>
          <FaBell className="nav-icon" />
          <span>Alertas</span>
        </Link>
        
        <a
          href="https://www.honeypress.cl"
          target="_blank"
          rel="noopener noreferrer"
          className="nav-link"
          onClick={(e) => handleExternalLink(e, 'https://www.honeypress.cl')}
        >
          <FaShoppingCart className="nav-icon" />
          <span>Tienda</span>
        </a>
        
        <Link to="/faq" className={`nav-link ${getLinkClassName('/faq')}`}>
          <FaQuestionCircle className="nav-icon" />
          <span>FAQ</span>
        </Link>
      </div>
    </nav>
  );
};

export default NavBar;
